const relevant = {
  state: {
    sapSatus: {}
  },
  mutations: {
    setSapSatus: (state, data) => {
      state.sapSatus = data
    }
  },
  actions: {}
}
export default relevant
